import { Dispatch, SetStateAction, useMemo } from "react";

import { ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme } from "@mui/material";
import TogglePinned from "src/components/Dashboard/TooglePinned/TogglePinned";
import { LocationModel } from "src/types/location";
import LocationType from "src/types/LocationType";

import { getStyles, isChildMenuItemSelected, getIconFromLocationType } from "../sidebar.helpers";
import RegionChip from "./RegionChip";

export function PinnedLocationRow({
  open,
  location,
  parent,
  setError,
  pathname,
  onSelect,
}: {
  open: boolean;
  location: LocationModel;
  parent?: LocationModel;
  setError: Dispatch<SetStateAction<string | null>> | ((msg: string | null) => void) | null;
  pathname: string;
  onSelect: (id: string, locationType: LocationType) => void;
}) {
  const theme = useTheme();
  const locationType = LocationType[location.Type as keyof typeof LocationType];
  const icon = useMemo(() => getIconFromLocationType(locationType), [locationType]);

  return (
    <ListItem
      secondaryAction={
        <TogglePinned fontSize={theme.fontSizes.lg} locationId={location.Id} type={locationType} setError={setError} edge='end' />
      }
    >
      <ListItemButton
        selected={isChildMenuItemSelected(pathname, location.Id, locationType)}
        sx={getStyles(theme).listItemButton(true)}
        onClick={() => onSelect(location.Id, locationType)}
      >
        <ListItemIcon sx={getStyles(theme).listItemIcon(open)}>{icon}</ListItemIcon>
        <ListItemText
          primaryTypographyProps={getStyles(theme).listItemPrimaryTypographyProps}
          primary={location.LocalName}
          sx={getStyles(theme).childListItemText(true)}
          secondary={parent ? <RegionChip parent={parent} /> : null}
        />
      </ListItemButton>
    </ListItem>
  );
}

export default PinnedLocationRow;
